import { loadBkDesignOrderContext } from './bkDesignOrderContext';
import { AXES_LANDMARK_IDS } from './alignmentLandmarks';

const STORAGE_PREFIX = 'bk_design:axes_landmarks:';

function storageKey(salesOrder, customer) {
  return `${STORAGE_PREFIX}${String(salesOrder).trim()}:${String(customer).trim()}`;
}

/**
 * @param {import('./alignmentLandmarks').LandmarkPositionsMap} positions
 * @param {{ sales_order: string, customer: string } | null} [ctx]
 */
export function persistBkAlignmentLandmarks(positions, ctx = loadBkDesignOrderContext()) {
  if (!ctx?.sales_order || !ctx?.customer || !positions) return false;
  try {
    localStorage.setItem(
      storageKey(ctx.sales_order, ctx.customer),
      JSON.stringify({ version: 1, positions, savedAt: Date.now() }),
    );
    return true;
  } catch (e) {
    console.warn('persistBkAlignmentLandmarks failed', e);
    return false;
  }
}

/**
 * @param {{ sales_order: string, customer: string } | null} [ctx]
 * @returns {import('./alignmentLandmarks').LandmarkPositionsMap | null}
 */
export function loadBkAlignmentLandmarks(ctx = loadBkDesignOrderContext()) {
  if (!ctx?.sales_order || !ctx?.customer) return null;
  try {
    const raw = localStorage.getItem(storageKey(ctx.sales_order, ctx.customer));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const positions = parsed?.positions;
    if (!positions || typeof positions !== 'object') return null;
    const ok = AXES_LANDMARK_IDS.every((id) => {
      const p = positions[id];
      return p && Number.isFinite(p.x) && Number.isFinite(p.y) && Number.isFinite(p.z);
    });
    return ok ? positions : null;
  } catch {
    return null;
  }
}

/**
 * @param {{ sales_order: string, customer: string } | null} [ctx]
 */
export function clearBkAlignmentLandmarks(ctx = loadBkDesignOrderContext()) {
  if (!ctx?.sales_order || !ctx?.customer) return;
  try {
    localStorage.removeItem(storageKey(ctx.sales_order, ctx.customer));
  } catch {
    /* ignore */
  }
}
